import { handleSignOut } from "../../common/handleSignOut";
import styles from "./AuthenticationError.module.scss";
import { Button } from "@material-ui/core";
import { ReactComponent as PractitionerStaff } from "../../../images/practitioner-staff.svg";
import { ReactComponent as SignoutIcon } from "../../../images/icon-signout.svg";

export interface UserAlreadyMappedError {
  onLogout: () => void;
}

export const UserAlreadyMappedError = () => {
  const logOut = () => {
    handleSignOut({ reason: "Authentication error", url: window.location.href })
  };
  return (
    <div className={styles.background}>
      <div className={styles.inner}>

        <div className={styles.content}>

          <div>
            <div className={styles.header}>
              Please sign in using your MedPoint credentials.
            </div>
            <div className={styles.body}>
              <PractitionerStaff />
              <div className={styles.message}>              
                You can’t access MedPoint straight from Clinical Manager.
                <br></br>
                Please click the sign out button below,
                <br></br>
                then sign in again using your <b>MedPoint credentials</b>.
              </div>
              <Button onClick={logOut} className={styles.secondaryButton} style={{
                width: "207px"
              }} startIcon={<SignoutIcon title="" />}>
                Sign out of MedPoint</Button>
            </div>
            <div className={styles.footer}>
              Illustrations by <a className={styles.link} href="https://www.freepik.com/" target="_blank">Freepik</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
